import { memo } from 'react'

import { Text } from 'common-components'
import * as Styled from './styled'

interface IProps {
  value: number
  isSelected: boolean
  onClick: (value: number) => void
  setNode: (node: HTMLDivElement) => void
}
const TtsVelocityValue: React.FC<IProps> = (props: IProps) => {
  const { value, isSelected, onClick, setNode } = props

  const handleOnClick = () => {
    onClick(value)
  }

  return (
    <Styled.TtsVelocityValueWrapper
      $isSelected={isSelected}
      onClick={handleOnClick}
      ref={isSelected ? setNode : null}
    >
      <Text type="h4" color="secondarySemiDark" lineHeight="15px">
        {value}
      </Text>
    </Styled.TtsVelocityValueWrapper>
  )
}

export default memo(TtsVelocityValue)
